module.exports = __webpack_public_path__ + "img/tutorial-03.602a85c1.jpg";